import { Salutation } from '@models/DomainModels/Master/salutation';
import { ColDef } from 'ag-grid-enterprise';

interface GridColumnParams {
  t: (key: string) => string;
}

export const gridColumnDefinitions = ({ t }: GridColumnParams): ColDef<Salutation>[] => {
  const columns: ColDef<Salutation>[] = [
    {
      field: 'name',
      flex: 1,
      filter: 'agSetColumnFilter',
      filterParams: { caseSensitive: false, applyMiniFilterWhileTyping: true },
      headerName: t('headers.name')
    }
  ];

  return columns;
};
